export default __webpack_public_path__ + "static/media/magnifying-glass.04555198.svg";